module.exports = __webpack_public_path__ + "static/media/thea.2e237ce7.png";